module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (this.user_id === undefined && parseInt(_vm.context.$store.state.config.user.level) < 99) ? [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Customer")]), _vm._v(" "), _c('v-select', {
    staticClass: "is-fullwidth",
    attrs: {
      "options": _vm.getCustomers(),
      "max-height": "200px"
    },
    model: {
      value: (_vm.user.agency),
      callback: function($$v) {
        _vm.$set(_vm.user, "agency", $$v)
      },
      expression: "user.agency"
    }
  })], 1)] : (parseInt(_vm.context.$store.state.config.user.level) < 99) ? [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Customer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.agency_name),
      expression: "user.agency_name"
    }],
    class: {
      'input': true,
      'is-disabled': true
    },
    attrs: {
      "type": "text",
      "name": "agency_name",
      "id": "agency_name"
    },
    domProps: {
      "value": (_vm.user.agency_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "agency_name", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('name'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('email'),
      'is-disabled': _vm.inProgress || this.user_id !== undefined
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('password'),
      'is-disabled': _vm.inProgress,
      'password': true
    },
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.admin),
      expression: "user.admin"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.admin) ? _vm._i(_vm.user.admin, null) > -1 : (_vm.user.admin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.admin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "admin", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "admin", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "admin", $$c)
        }
      }
    }
  }), _vm._v("\n            Admin\n          ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.active),
      expression: "user.active"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.active) ? _vm._i(_vm.user.active, null) > -1 : (_vm.user.active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "active", $$c)
        }
      }
    }
  }), _vm._v("\n            Active\n          ")])]), _vm._v(" "), (_vm.canEditHide) ? _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hideUser),
      expression: "hideUser"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.hideUser) ? _vm._i(_vm.hideUser, null) > -1 : (_vm.hideUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.hideUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hideUser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.hideUser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hideUser = $$c
        }
      }
    }
  }), _vm._v("\n            Hide\n          ")])]) : _vm._e()]], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.errors.any(),
      'is-loading': _vm.inProgress
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ed72536","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/users/Client.vue
// module id = 1141
// module chunks = 39